import { create } from 'zustand'

interface State {
    stores_downloaded: number
    total_stores: number | null
    set_total_stores: (total_stores: number | null) => void
    set_stores_downloaded: (stores_downloaded: number) => void
    isLoader: boolean
    resetValues: () => void
    set_isLoader: (isLoader: boolean) => void
}
export const useLoaderSaveStores = create<State>((set, get) => ({
    total_stores: null,
    stores_downloaded: 0,
    set_total_stores: (total_stores: number | null) => {

        set({ total_stores: total_stores })

    },
    set_stores_downloaded: (stores_downloaded: number) => {

        set({ stores_downloaded: stores_downloaded })

        const totalStores = get().total_stores;

        if (totalStores !== null) {

            if (totalStores <= stores_downloaded) {

                set({ isLoader: false })
            }

        }
    },
    isLoader: true,
    resetValues: () => set({ total_stores: null, stores_downloaded: 0, isLoader: true }),
    set_isLoader: (isLoader: boolean) => set({ isLoader: isLoader })
})) 


